import FaqThemeCardList from '.';
import type { Meta, StoryObj } from '@storybook/vue3';
import { type FaqThemeCardProps } from 'ewi-ui/components/2-molecules/FaqThemeCard';

const sampleCards: FaqThemeCardProps[] = [
  {
    title: 'Billing & Payments',
    icon: 'card',
    faqItems: [
      { question: 'Wie kann ich meinen Stromverbrauch senken?', href: '#' },
      {
        question: 'Was ist der Unterschied zwischen Grund- und Arbeitspreis?',
        href: '#',
      },
      { question: 'Wie kann ich meinen Zählerstand übermitteln?', href: '#' },
    ],
    redirectUrl: '/billing-faq',
  },
  {
    title: 'Contract & Service',
    icon: 'gas',
    faqItems: [
      { question: 'Wie kann ich meinen Tarif wechseln?', href: '#' },
      { question: 'Wo finde ich meine Vertragsdaten?', href: '#' },
      { question: 'Wie kündige ich meinen Vertrag?', href: '#' },
    ],
    redirectUrl: '/contract-faq',
  },
  {
    title: 'Technical Support',
    icon: 'house',
    faqItems: [
      { question: 'Stromausfall - was kann ich tun?', href: '#' },
      { question: 'Probleme mit dem Smart Meter?', href: '#' },
      { question: 'Wie funktioniert die App?', href: '#' },
    ],
    redirectUrl: '/technical-faq',
  },
  {
    title: 'Account & Login',
    icon: 'heatflow',
    faqItems: [
      { question: 'Passwort vergessen - was tun?', href: '#' },
      { question: 'Wie ändere ich meine Daten?', href: '#' },
      { question: 'Probleme beim Einloggen?', href: '#' },
    ],
    redirectUrl: '/account-faq',
  },
];

const meta = {
  title: 'Organisms/FaqThemeCardList',
  component: FaqThemeCardList,
  render: (args, { globals }) => ({
    components: { FaqThemeCardList },
    setup() {
      return { args, globals };
    },
    template:
      '<faqThemeCardList v-bind="args">{{ args.default }}</faqThemeCardList>',
  }),
  tags: ['autodocs'],
  argTypes: {
    title: { control: 'text' },
    cards: { control: 'object' },
    align: { control: 'select', options: ['left', 'center', 'right'] },
  },
  args: {
    title: 'FAQ Themenbereiche',
    cards: sampleCards,
    align: 'center',
  },
} satisfies Meta<typeof FaqThemeCardList>;

export default meta;
type Story = StoryObj<typeof meta>;

export const Default: Story = {
  ...meta,
  args: {
    cards: sampleCards,
  },
};

export const TwoCards: Story = {
  ...meta,
  args: {
    cards: sampleCards.slice(0, 2),
  },
};

export const SevenCards: Story = {
  ...meta,
  args: {
    cards: [
      ...sampleCards,
      ...sampleCards.slice(0, 3), // Add first 3 cards again to make 7 total
    ],
  },
};
